<script>
import {
  LpMarkerBtn,
} from '@thehotelsnetwork/lampo';
import {
  PencilIcon,
} from '@thehotelsnetwork/icons/vue/linear';

export default {
  components: {
    LpMarkerBtn,
    PencilIcon,
  },
  props: {
    disabled: {
      type: Boolean,
    },
  },
};
</script>

<template>
  <div
    class="visible-in-action text-sm font-normal text-base-900"
    :class="{ 'pointer-events-none': disabled }"
  >
    <LpMarkerBtn>
      <div class="flex items-center gap-2">
        <slot />
        <PencilIcon class="visible-in-action__icon opacity-0 w-4 h-4" />
      </div>
    </LpMarkerBtn>
  </div>
</template>

<style scoped>
.visible-in-action {
  width: fit-content;
}
.visible-in-action__icon {
  transition: opacity .3s;
}
.visible-in-action:hover .visible-in-action__icon {
  @apply opacity-100;
}
</style>
